import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningRed } from 'assets/icons/red-alert.svg';
import { Modal, TextAreaField } from 'components';
import SuccessModal from '../successModal';
import { addComment } from 'store/appTrack/actions';

const RejectModal = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  outcome,
  taskId,
  businessKey
}) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const [successModalVisible ,setSuccessVisible] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const renderContent = () => {
    {
        return (
          <div>
            <WarningRed></WarningRed>
            <div className="content-title-2 font-size-18 mb-2">
                Απόρριψη Αίτησης
            </div>
                Πρόκειται να προχωρήσετε σε Απόρριψη της Αίτησης με αριθμό {businessKey}. 
                Παρακαλούμε επιβεβαιώστε την ενέργεια εισάγοντας ταυτόχρονα την 
                αιτιολογία της απόρριψης. Διαφορετικά, επιλέξτε Ακύρωση.
                <div className="mt-2">
                    <TextAreaField
                      label={<div className='content-title-3 font-size-16'>Αιτιολογία Απόρριψης <span className='color-red'>*</span></div>}
                      placeholder={'Αιτιολογία Απόρριψης'}
                      value={rejectMessage}
                      maxLength={500}
                      onChange={event =>
                        setRejectMessage(event.target.value)
                      }
                    />
                  </div>
          </div>
        );
      
    }
  };

  const submit = () => {
    setIsVisible(false);
    handleSubmit(rejectMessage);
    setRejectMessage("");
    // dispatch(addComment(taskId, rejectMessage));
  };

  return (
    <>
      <Modal
        isVisible={isVisible}
        setVisible={setIsVisible}
        handleCancel={() => {
          setIsVisible(false);
          setRejectMessage("");
        }}
        handleConfirm={submit}
        cancelText={'Ακύρωση'}
        okText={'Απόρριψη'}
        Icon={WarningRed }
        outcome={outcome}
        user={user}
        submitDisabled={!rejectMessage || rejectMessage == ""}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
      <SuccessModal isVisible={successModalVisible} setVisible={setSuccessVisible}></SuccessModal>
    </>
  );
};

export default RejectModal;
